module.exports = __webpack_public_path__ + "img/cave27.7390fdbf.jpg";